export const COLUNAS_DEFAULT_MODULE_MSG_CLICK_MASSA = [
  {
    module: 'MSG_CLICK_MASSA',
    colunas: [
      { field: 'acao', active: true, removable: false },
      { field: 'buscar_contatos', active: true, removable: true },
      {
        field: 'horario',
        active: true,
        removable: true
      },
      { field: 'msg', active: true, removable: true }
    ]
  }
];
